<nav id="header" class="navbar navbar-expand navbar-dark bg-dark p-0 fixed-top"
     [attr.aria-label]="'Header' | translate">
  <button class="btn btn-dark menu-toggler-btn mr-2" (click)="toggleHeader()"
          [attr.aria-label]="toggleKey | translate">
    <span class="fas fa-bars fa-fw"></span>
  </button>
  <a class="navbar-brand" [routerLink]="welcomePage">
    <img [src]="appLogo" class="applogo ml-1 mr-2" alt="">{{appTitleKey | translate}}
  </a>
  <ul class="navbar-nav ml-auto header-list">
    <ng-content></ng-content>
  </ul>
</nav>
